// Variant B: plainer, broader-audience tone for the A/B test. Same layout, different words.
export const VARIANT_B = {
  hero: {
    badge: "Personal Info Protection",
    titleTop: "Strangers can",
    titleMuted: "find your home.",
    titleLead: "Take it all",
    titleAccent: "offline.",
    subtext:
      "A simple, step-by-step guide to stop companies and strangers from finding your home address, phone number and personal info online. No tech skills needed, just follow along.",
    ctaNote: "Instant access · One-time payment",
  },
  manifesto: {
    heading: "12 simple steps. Off the radar.",
    sub: "Work through it step by step, removing your info from the web and locking down your phone, accounts and devices, one at a time.",
  },
  testimonials: [
    { handle: "Parent of two", role: "Ohio", quote: "I'm not technical at all. Every step told me exactly which button to tap. I locked down my whole family's phones in an afternoon." },
    { handle: "Small business owner", role: "Texas", quote: "After a customer showed up at my house, I needed my address gone. This walked me through removing it from 40+ sites in a weekend." },
    { handle: "Nurse", role: "Florida", quote: "Someone was looking me up online. This gave me a clear plan with no jargon. My address and number are finally off the search results." },
    { handle: "Retired teacher", role: "Arizona", quote: "Worth every penny. I finally understand what was public about me, and now it's not. Simple enough that I actually finished it." },
  ],
};
